import { PatchNotes } from "../../types/patches";

export const patch: PatchNotes = {
  id: "patch-11.0.1201",
  buildId: "11.0.1201",
  name: "Patch 11.0.1201",
  season: 8,
  type: "patch",
  officialUrl: "https://www.ageofempires.com/news/age-of-empires-iv-patch-11-1-1201/",
  summary: "",
  introduction: `
![](https://cdn.ageofempires.com/aoe/wp-content/uploads/2024/08/Season_Eight_Patch_Banner_1920x1080-1080x608.webp)
"Hello, and welcome to the latest set of changes and bug fixes planned for Season Eight! This patch includes more significant balance changes; map fixes and a map pool update; and two new events, including a seasonal Map Monsters game mode."`,
  date: new Date("2024-08-22T17:00:00Z"),
  sections: [

  ],
};
